export const UNKNOWN_HTTP_ERROR = Error('Error llamado HTTP');
